import * as z from 'zod';

export const authenticationTypeSchema = z.enum(['api key', 'oauth']);
export type AuthenticationTypeSchema = z.infer<typeof authenticationTypeSchema>;

export const authenticationTypeMutationSchema = authenticationTypeSchema.nullable();
export const authenticationTypeQuerySchema = z.enum(['api key', 'oauth']);
export const authenticationTypeFormSchema = z.object({
  name: z.string(),
  value: z.enum(['api key', 'oauth']),
});

export type AuthenticationTypeQuerySchema = z.infer<typeof authenticationTypeQuerySchema>;
export type AuthenticationTypeFormSchema = z.infer<typeof authenticationTypeFormSchema>;
export type AuthenticationTypeMutationSchema = z.infer<typeof authenticationTypeMutationSchema>;

export const defaultAuthenticationType: AuthenticationTypeFormSchema = { name: 'API Key', value: 'api key' };

export function strToAuthenticationType(
  authenticationType: AuthenticationTypeQuerySchema
): AuthenticationTypeFormSchema {
  return authenticationType === 'api key' ? authenticationTypeOptions[0] : authenticationTypeOptions[1];
}

export function authenticationTypeToStr(authenticationType?: AuthenticationTypeFormSchema): AuthenticationTypeSchema {
  return authenticationType?.value || 'api key';
}

export function authenticationTypeToStrByName(authenticationType?: AuthenticationTypeFormSchema): string {
  return authenticationType?.name || 'API Key';
}

export const authenticationTypeOptions: AuthenticationTypeFormSchema[] = [
  defaultAuthenticationType,
  { name: 'OAuth', value: 'oauth' },
];
